/**
 * Leasing.ai Pixel Block
 *
 * Metadata-only injection block. The custom token holds the official snippet
 * (script + img), either URL, or a bare pid. SSG extracts the pid and bakes
 * the canonical loader script + hidden image pixel into static HTML — the
 * vendor requires those tags in the document, not injected after load.
 */

import type { BlockDefinition, BlockProps } from '../../types';
import type { ComponentContentSchema } from '@vibesites/runtime';

function LeasingAiPixelComponent(_props: BlockProps) {
  return null;
}

const contentSchema: ComponentContentSchema = {
  slot: 'LeasingAiPixel',
  displayName: 'Leasing.ai Pixel',
  tokens: {
    pixel: {
      label: 'Leasing.ai snippet or property ID',
      type: 'text',
      defaultField: 'custom_leasing_ai',
      suggestedFields: ['custom_leasing_ai'],
      description:
        'Official leasing.ai snippet (loader script + hidden image pixel), either URL, or the bare pid. Full snippets are parsed for the pid. Maps to custom_leasing_ai by default. Production SSG bakes the tags into the page HTML.',
      required: true,
    },
  },
};

export const leasingAiPixelBlock: BlockDefinition = {
  id: 'leasing-ai-pixel',
  name: 'Leasing.ai Pixel',
  description:
    'Leasing.ai widget loader and tracking pixel. Reads the official snippet from custom_leasing_ai; production SSG bakes the loader script and hidden image pixel into static HTML.',
  category: 'Analytics',
  placement: 'injection',
  defaultScope: 'global',
  component: LeasingAiPixelComponent,
  contentSchema,
  tags: ['leasing.ai', 'leasingai', 'pixel', 'tracking', 'ads', 'widget'],
};
